module.exports = __webpack_public_path__ + "img/Slika15.d1c12244.png";